export default __webpack_public_path__ + "static/sissy-d6bd87342d01f67bdd13bae952941587.jpg";